import React, { Component } from 'react'
import './navBar.css'
import {aboutUser }from '../../const/about_user'
import {Image , Nav , Navbar  } from 'react-bootstrap'
import SocialIcons from '../shared/social_icons/index'
import Logo from '../../assets/img/wejdi_logo-navBar.jpg'
import { withRouter } from "react-router";

const links = [
  { id:2 , name: "About Me", to: "#about" },
  { id:3 , name: "Skills", to: "#skills" },
  { id:4 , name: "Projects", to: "#project" },
  { id:5 , name: "Articles", to: "#articles" },
]

 class navBar extends Component {


  socialLinks = () => {
    let socials = []

    aboutUser.socialLinks.map(el => {

      if (el.link !== "") {

        socials.push({
          name: el.className,
          url: el.link,
          icon: el.icon,
        })
      }

    })

    return socials

  }

  changePath =()=> {

    this.props.history.push("/home")
  }

    render() {
        return (

          <Navbar bg="dark" variant="dark" expand="lg" fixed="top" >
            <Navbar.Brand > <Image src={Logo} rounded className="navBar-logo" onClick={this.changePath}/> </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                {
                  links.map(el => <Nav.Link className="navBar-links" key={el.id} href={el.to}>{el.name}</Nav.Link>)
                }
              </Nav>
              <Nav>
              <Nav.Link className="navBar-links"  href='#contact'>Contact </Nav.Link>
                <SocialIcons />
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        
     
        );
      }
}

export default  withRouter (navBar)